var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "main-content" }, [
    _c("section", { staticClass: "section section-hero-area" }, [
      _vm._m(0),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "row1 flex flex-wrap" },
        [
          _vm.browserWarning
            ? _c("div", { staticClass: "col-md-12 alert alert-danger" }, [
                _vm._v("\n        Ваш браузер "),
                _c("strong", [_vm._v("Yandex")]),
                _vm._v(
                  "! Во избежании некорректного отображения данных (подмена контента) просим\n        использовать браузер "
                ),
                _c("strong", [_vm._v("Google Chrome / Safari / Mozilla")]),
                _vm._v(".\n      "),
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.messageForGroup()
            ? _c("div", { staticClass: "col-md-12 alert alert-info" }, [
                _c("h4", [
                  _vm._v("Изменения в работе колл-центра с 22 марта !!!"),
                ]),
                _vm._v(" "),
                _vm._m(1),
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.loading
            ? _c("pulse-loader", {
                staticClass: "text-center",
                attrs: { loading: _vm.loading, color: _vm.loadingColor },
              })
            : _vm._e(),
          _vm._v(" "),
          _c("div", { staticClass: "col-md-4" }, [
            _vm.cardsInUse.length
              ? _c("div", [
                  _vm.systemErrors.invoice && _vm.systemErrors.invoice.length
                    ? _c("div", { staticClass: "card" }, [
                        _vm._m(2),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "card-body" },
                          _vm._l(
                            _vm.systemErrors.invoice,
                            function (err, index) {
                              return _c("p", [
                                _vm._v(
                                  "\n                " +
                                    _vm._s(err.text) +
                                    " - " +
                                    _vm._s(err.connectable.prep) +
                                    "\n                "
                                ),
                                _c(
                                  "button",
                                  {
                                    staticClass:
                                      "btn btn-sm btn-outline-success",
                                    on: {
                                      click: function ($event) {
                                        return _vm.acknowledgeNotification(
                                          "invoice",
                                          index
                                        )
                                      },
                                    },
                                  },
                                  [
                                    _vm._v(
                                      "\n                  Закрыть\n                "
                                    ),
                                  ]
                                ),
                              ])
                            }
                          ),
                          0
                        ),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  false
                    ? _c("div", { staticClass: "card" }, [
                        _vm._m(3),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "card-body" },
                          _vm._l(_vm.cardsInUse, function (card, index) {
                            return _c("div", { staticClass: "card_info" }, [
                              _c("p", [
                                _c("strong", [_vm._v(_vm._s(card.type))]),
                                _vm._v(
                                  ": " +
                                    _vm._s(card.number) +
                                    "\n                "
                                ),
                              ]),
                              _vm._v(" "),
                              _c("p", [_vm._v(_vm._s(card.owner.full_name))]),
                              _vm._v(" "),
                              _c("p", [
                                _c("strong", [
                                  _vm._v(
                                    _vm._s(
                                      _vm.moment(card.start_use, "DD.MM.YYYY")
                                    )
                                  ),
                                ]),
                                _vm._v(" -\n                  "),
                                _c("strong", [
                                  _vm._v(_vm._s(_vm.daysRemain(card, true))),
                                ]),
                                _vm._v(" "),
                                _c(
                                  "span",
                                  { staticClass: "badge badge-info" },
                                  [
                                    _vm._v(
                                      "Активна еще " +
                                        _vm._s(_vm.daysRemain(card)) +
                                        " дня(ей)"
                                    ),
                                  ]
                                ),
                              ]),
                              _vm._v(" "),
                              _vm.showCredentials
                                ? _c("div", [
                                    _c("p", [
                                      _c("strong", [_vm._v("Login")]),
                                      _vm._v(": " + _vm._s(card.access.login)),
                                    ]),
                                    _vm._v(" "),
                                    _c("p", [
                                      _c("strong", [_vm._v("Password")]),
                                      _vm._v(": " + _vm._s(card.access.pass)),
                                    ]),
                                  ])
                                : _c("div", [
                                    _c(
                                      "button",
                                      {
                                        staticClass: "btn btn-sm btn-info",
                                        attrs: { type: "button" },
                                        on: {
                                          click: function ($event) {
                                            _vm.showCredentials = true
                                          },
                                        },
                                      },
                                      [
                                        _vm._v(
                                          "\n                    показать доступы\n                  "
                                        ),
                                      ]
                                    ),
                                  ]),
                              _vm._v(" "),
                              index + 1 != _vm.cardsInUse.length
                                ? _c("hr")
                                : _vm._e(),
                            ])
                          }),
                          0
                        ),
                      ])
                    : _vm._e(),
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.inCashRequests.length
              ? _c("div", [
                  _c("div", { staticClass: "card" }, [
                    _vm._m(4),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "card-body card_info" },
                      _vm._l(_vm.inCashRequests, function (request, ind) {
                        return request
                          ? _c("div", [
                              _c("p", [
                                _vm._v(_vm._s(request.division.user.name)),
                              ]),
                              _vm._v(" "),
                              _c("p", [
                                _vm._v(
                                  "\n                  запрос на снятие:\n                  "
                                ),
                                _c("strong", [
                                  _vm._v(
                                    _vm._s(request.sum.toLocaleString("ru-RU"))
                                  ),
                                ]),
                                _vm._v(" "),
                                _c("span", { staticClass: "text-muted" }, [
                                  _vm._v(
                                    _vm._s(
                                      _vm.moment(
                                        request.report_date,
                                        "HH:mm DD.MM.YYYY"
                                      )
                                    )
                                  ),
                                ]),
                              ]),
                              _vm._v(" "),
                              _c("p", [
                                _vm._v(
                                  "\n                  Старый конверт:\n                  "
                                ),
                                _c("strong", [
                                  _vm._v(
                                    _vm._s(
                                      request.cash_amount.toLocaleString(
                                        "ru-RU"
                                      )
                                    )
                                  ),
                                ]),
                              ]),
                              _vm._v(" "),
                              _c("hr"),
                              _vm._v(" "),
                              _c("p", [
                                _vm._v(
                                  "\n                  Заявки:\n                  "
                                ),
                                _c("strong", [
                                  _vm._v(
                                    _vm._s(
                                      request.adm_amount.toLocaleString("ru-RU")
                                    )
                                  ),
                                ]),
                              ]),
                              _vm._v(" "),
                              _c("p", [
                                _vm._v(
                                  "\n                  ЗП:\n                  "
                                ),
                                _c("strong", [
                                  _vm._v(
                                    _vm._s(
                                      request.salary_amount.toLocaleString(
                                        "ru-RU"
                                      )
                                    )
                                  ),
                                ]),
                              ]),
                              _vm._v(" "),
                              _c("p", [
                                _vm._v(
                                  "\n                  Почтовые р.:\n                  "
                                ),
                                _c("strong", [
                                  _vm._v(
                                    _vm._s(
                                      request.post_amount.toLocaleString(
                                        "ru-RU"
                                      )
                                    )
                                  ),
                                ]),
                              ]),
                              _vm._v(" "),
                              _c("hr"),
                              _vm._v(" "),
                              _c("p", [
                                _vm._v(
                                  "\n                  Калькуляция: " +
                                    _vm._s(request.sum) +
                                    " +\n                  " +
                                    _vm._s(Math.round(request.cash_amount)) +
                                    " -\n                  " +
                                    _vm._s(request.adm_amount) +
                                    " - " +
                                    _vm._s(request.salary_amount) +
                                    " -\n                  " +
                                    _vm._s(request.post_amount) +
                                    "\n                "
                                ),
                              ]),
                              _vm._v(" "),
                              _c("p", [
                                _vm._v(
                                  "\n                  Новый конверт:\n                  "
                                ),
                                _c("strong", [
                                  _vm._v(
                                    _vm._s(
                                      (
                                        request.sum -
                                        request.adm_amount -
                                        request.salary_amount -
                                        request.post_amount +
                                        request.cash_amount
                                      ).toLocaleString("ru-RU")
                                    )
                                  ),
                                ]),
                              ]),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "flex flex-end" },
                                [
                                  _c(
                                    "vue-ladda",
                                    {
                                      attrs: {
                                        "button-class": "btn btn-warning",
                                        "data-style": "zoom-in",
                                        loading: _vm.btnLoading.reject,
                                      },
                                      on: {
                                        click: function ($event) {
                                          return _vm.updateRequest(
                                            false,
                                            request,
                                            ind
                                          )
                                        },
                                      },
                                    },
                                    [_vm._v("Отменить\n                  ")]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "vue-ladda",
                                    {
                                      attrs: {
                                        "button-class": "btn btn-success m-l-5",
                                        "data-style": "zoom-in",
                                        loading: _vm.btnLoading.accept,
                                      },
                                      on: {
                                        click: function ($event) {
                                          return _vm.updateRequest(
                                            true,
                                            request,
                                            ind
                                          )
                                        },
                                      },
                                    },
                                    [_vm._v("Подтвердить\n                  ")]
                                  ),
                                ],
                                1
                              ),
                            ])
                          : _vm._e()
                      }),
                      0
                    ),
                  ]),
                ])
              : _vm._e(),
            _vm._v(" "),
            !_vm.loading && this.$can("reports/DivisionsAllBalance")
              ? _c("div", [
                  _c("div", { staticClass: "card" }, [
                    _vm._m(5),
                    _vm._v(" "),
                    _c("div", { staticClass: "card-body" }, [
                      !_vm.showBalance
                        ? _c("div", { staticClass: "text-right" }, [
                            _c(
                              "button",
                              {
                                staticClass: "btn btn-outline-success",
                                on: { click: _vm.showDivBalance },
                              },
                              [
                                _vm._v(
                                  "\n                  Показать сальдо\n                "
                                ),
                              ]
                            ),
                          ])
                        : _c("div", [_c("DateBalance")], 1),
                    ]),
                  ]),
                ])
              : _vm._e(),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "col-md-4" }, [
            _vm.expireDates && Object.keys(_vm.expireDates).length
              ? _c("div", [
                  _c("div", { staticClass: "card" }, [
                    _vm._m(6),
                    _vm._v(" "),
                    _c("div", { staticClass: "card-body" }, [
                      _vm.expireDates &&
                      ((_vm.expireDates.expired &&
                        _vm.expireDates.expired.length) ||
                        (_vm.expireDates.soon && _vm.expireDates.soon.length))
                        ? _c("div", { staticClass: "card_info" }, [
                            _vm.expireDates.expired.length
                              ? _c(
                                  "div",
                                  [
                                    _vm._l(
                                      _vm.expireDates.expired,
                                      function (exp, index) {
                                        return _c("p", { key: index }, [
                                          _vm._v(
                                            "\n                    " +
                                              _vm._s(exp.drug.title) +
                                              " -\n                    "
                                          ),
                                          _c("strong", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.moment(
                                                  exp.actual_date,
                                                  "DD.MM"
                                                )
                                              ) +
                                                " /\n                      " +
                                                _vm._s(
                                                  _vm.moment(
                                                    exp.expire_date,
                                                    "DD.MM.YYYY"
                                                  )
                                                )
                                            ),
                                          ]),
                                        ])
                                      }
                                    ),
                                    _vm._v(" "),
                                    _c("div", { staticClass: "text-right" }, [
                                      _c(
                                        "button",
                                        {
                                          staticClass: "btn btn-sm btn-success",
                                          on: {
                                            click: function ($event) {
                                              return _vm.openExpireDates(
                                                "expired"
                                              )
                                            },
                                          },
                                        },
                                        [
                                          _vm._v(
                                            "\n                      Проверить\n                    "
                                          ),
                                        ]
                                      ),
                                    ]),
                                  ],
                                  2
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.expireDates.soon.length
                              ? _c(
                                  "div",
                                  [
                                    _c(
                                      "p",
                                      { staticClass: "badge badge-info" },
                                      [
                                        _vm._v(
                                          "\n                    Утратят актуальность на протяжении 10 дней\n                  "
                                        ),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _vm._l(
                                      _vm.expireDates.soon,
                                      function (exp, index) {
                                        return _c(
                                          "p",
                                          { key: `soon_${index}` },
                                          [
                                            _vm._v(
                                              "\n                    " +
                                                _vm._s(exp.drug.title) +
                                                " -\n                    "
                                            ),
                                            _c("strong", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.moment(
                                                    exp.actual_date,
                                                    "DD.MM"
                                                  )
                                                ) +
                                                  " /\n                      " +
                                                  _vm._s(
                                                    _vm.moment(
                                                      exp.expire_date,
                                                      "DD.MM.YYYY"
                                                    )
                                                  )
                                              ),
                                            ]),
                                          ]
                                        )
                                      }
                                    ),
                                    _vm._v(" "),
                                    _c("div", { staticClass: "text-right" }, [
                                      _c(
                                        "button",
                                        {
                                          staticClass: "btn btn-sm btn-success",
                                          on: {
                                            click: function ($event) {
                                              return _vm.openExpireDates("soon")
                                            },
                                          },
                                        },
                                        [
                                          _vm._v(
                                            "\n                      Проверить\n                    "
                                          ),
                                        ]
                                      ),
                                    ]),
                                  ],
                                  2
                                )
                              : _vm._e(),
                          ])
                        : _c("div", [
                            _c("p", [
                              _vm._v(
                                "Препаратов с итекающими сроками годности не найдено"
                              ),
                            ]),
                          ]),
                    ]),
                  ]),
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.woExpireDates && _vm.woExpireDates.length
              ? _c("div", [
                  _c("div", { staticClass: "card" }, [
                    _vm._m(7),
                    _vm._v(" "),
                    _c("div", { staticClass: "card-body" }, [
                      _c(
                        "table",
                        { staticClass: "table table-sm table-hover" },
                        [
                          _c(
                            "tbody",
                            _vm._l(
                              _vm.sortBy(_vm.woExpireDates),
                              function (drug) {
                                return _c("tr", [
                                  _c("td", [_vm._v(_vm._s(drug.name))]),
                                ])
                              }
                            ),
                            0
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c("div", { staticClass: "text-right" }, [
                        _c(
                          "button",
                          {
                            staticClass: "btn btn-sm btn-success",
                            on: {
                              click: function ($event) {
                                return _vm.openExpireDates("onStore")
                              },
                            },
                          },
                          [
                            _vm._v(
                              "\n                  Показать\n                "
                            ),
                          ]
                        ),
                      ]),
                    ]),
                  ]),
                ])
              : _vm._e(),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "col-md-4" }, [
            _vm.uploadBlackList && _vm.uploadBlackList.length
              ? _c("div", [
                  _c("div", { staticClass: "card" }, [
                    _vm._m(8),
                    _vm._v(" "),
                    _c("div", { staticClass: "card-body" }, [
                      !_vm.showBlock.blackList
                        ? _c("div", [
                            _c(
                              "button",
                              {
                                staticClass: "btn btn-outline-info",
                                on: {
                                  click: function ($event) {
                                    _vm.showBlock.blackList = true
                                  },
                                },
                              },
                              [_vm._v("Показать список")]
                            ),
                          ])
                        : _c("div", [
                            _c(
                              "table",
                              { staticClass: "table table-sm table-hover" },
                              [
                                _c(
                                  "tbody",
                                  _vm._l(
                                    _vm.sortBy(_vm.uploadBlackList, "drug"),
                                    function (record) {
                                      return _c("tr", [
                                        _c("td", [
                                          _vm._v(
                                            "\n                      " +
                                              _vm._s(record.drug.name) +
                                              "\n                      "
                                          ),
                                          record.comments
                                            ? _c("p", [
                                                _c("i", [
                                                  _vm._v(
                                                    _vm._s(
                                                      record.comments.comment
                                                    )
                                                  ),
                                                ]),
                                              ])
                                            : _vm._e(),
                                        ]),
                                        _vm._v(" "),
                                        _c("td", [
                                          _vm._v(
                                            _vm._s(
                                              _vm.moment(
                                                record.actual_date,
                                                "DD.MM.YYYY"
                                              )
                                            )
                                          ),
                                        ]),
                                      ])
                                    }
                                  ),
                                  0
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            _c("div", { staticClass: "text-right" }, [
                              _c(
                                "button",
                                {
                                  staticClass: "btn btn-sm btn-success",
                                  on: {
                                    click: function ($event) {
                                      return _vm.mixinGoToRouter(
                                        "uploadsBlackList"
                                      )
                                    },
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n                    Перейти\n                  "
                                  ),
                                ]
                              ),
                            ]),
                          ]),
                    ]),
                  ]),
                ])
              : _vm._e(),
          ]),
        ],
        1
      ),
      _vm._v(" "),
      _vm.notifications.length
        ? _c(
            "div",
            _vm._l(_vm.notifications, function (notification) {
              return _c("div", { staticClass: "card" }, [
                _c("div", { staticClass: "card-header" }, [
                  _c("h5", [
                    _vm._v(
                      "\n            " +
                        _vm._s(_vm.printNotificationTitle(notification)) +
                        " (" +
                        _vm._s(notification.created_at) +
                        ")\n          "
                    ),
                  ]),
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "card-body" },
                  [
                    _c(_vm.notificationTemplates[2], {
                      tag: "component",
                      attrs: { data: notification.sub_object },
                    }),
                  ],
                  1
                ),
              ])
            }),
            0
          )
        : _vm._e(),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", [
      _c("h4", [
        _c("p", { staticClass: "mb-1" }, [
          _vm._v("Добро пожаловать на рабочее место!\n          "),
        ]),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("p", [
      _vm._v("\n          Описание\n          "),
      _c("strong", [
        _c(
          "a",
          {
            attrs: {
              target: "_blank",
              href: "https://docs.google.com/document/d/1-G-4TkIZ8UZAa_mEPKEPTwXP1dIFGoAFo3LQEP-4MG8/edit?usp=sharing",
            },
          },
          [_vm._v("ТУТ")]
        ),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "card-header bg-warning" }, [
      _c("h6", [_vm._v("Ошибки автопроведения накладных")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "card-header bg-info" }, [
      _c("h6", [_vm._v("Активные карты")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "card-header bg-info" }, [
      _c("h6", [_vm._v("Запросы на снятие")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "card-header bg-info" }, [
      _c("h6", [_vm._v("Сальдо дивизионов")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "card-header bg-info" }, [
      _c("h6", [_vm._v("Сроки годности (утратили актуальность)")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "card-header bg-info" }, [
      _c("h6", [
        _vm._v(
          "\n                Препараты, которые есть на складе МСК, но не имеют сроков\n                годности\n              "
        ),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "card-header bg-info" }, [
      _c("h6", [_vm._v("Препараты в черном списке на выгрузку в справочные")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }